import { createSelector } from 'reselect';
import { getAllSureMotorClaim } from './index';
import { getIncidentDetailsForm } from './incidentDetails';

const getAllReferenceDataState = createSelector(
    getAllSureMotorClaim,
    (allSureMotorClaim) => allSureMotorClaim.referenceData
);

export const getAmcApiStatus = createSelector(getAllReferenceDataState, (referenceData) => referenceData.apiStatus);

export const getAmcReferenceNumber = createSelector(
    getAllReferenceDataState,
    (referenceData) => referenceData.referenceNumber
);

export const getApplicationData = createSelector(
    getAllReferenceDataState,
    (referenceData) => referenceData.applicationData
);

// export const getAllSureMotorFieldsToBeValidated = createSelector(getIncidentDetailsForm, (incidentDetailsForm) => {
//     const { vehicleModel, vehicleMake } = incidentDetailsForm;
//     const incidentDetails = { ...incidentDetailsForm };
//     if (vehicleModel?.value !== 'OTHER') delete incidentDetails.mentionedVehicleModel;
//     if (vehicleMake?.value !== 'OTHER') delete incidentDetails.mentionedVehicleMake;
//     return incidentDetails;
// });

export const getAmcReferenceData = createSelector(getApplicationData, ({ vehicleMakeData, vehicleModelData }) => ({
    vehicleMakeReferenceData: Object.values(vehicleMakeData)?.map((make) => ({ value: make, label: make })),
    vehicleModelReferenceData: [
        ...Object.values(vehicleModelData)?.map((make) => ({ value: make, label: make })),
        ...(Object.values(vehicleModelData)?.includes('OTHER') ? [] : [{ value: 'OTHER', label: 'OTHER' }]),
    ],
    alternatePersonOptionsReferenceData: [
        {
            label: 'Friends',
            value: 'Friends',
        },
        {
            label: 'Family',
            value: 'Family',
        },
        {
            label: 'None',
            value: 'None',
        },
    ],
    categoryTypeReferenceData: [
        {
            label: 'Glass/Windscreen claim',
            value: 'WINDSCREEN',
        },
        {
            label: 'Theft/Hijack claim',
            value: 'THEFT',
        },
        {
          label: "Accidental/Own damage/Third party claim",
          value: "ACCIDENTAL"
        },
    ],
    windScreenReferenceData: [
        {
            label: 'Tinted',
            value: 'Tinted',
        },
        {
            label: 'Shatterproof',
            value: 'Shatterproof',
        },
        {
            label: 'Clear',
            value: 'Clear',
        },
        {
            label: 'Armour Plated',
            value: 'Armour Plated',
        },
    ],
    driverLicenseCodeReferenceData: [
        {
            label: 'A',
            value: 'A',
        },
        {
            label: 'A1',
            value: 'A1',
        },
        {
            label: 'B',
            value: 'B',
        },
        {
            label: 'C',
            value: 'C',
        },
        {
            label: 'C1',
            value: 'C1',
        },
        {
            label: 'EB',
            value: 'EB',
        },
        {
            label: 'EC',
            value: 'EC',
        },
        {
            label: 'EC1',
            value: 'EC1',
        },
        {
            label: 'F',
            value: 'F',
        },
        {
            label: 'H',
            value: 'H',
        },
    ],
    witnessReferenceData: [
        {
            label: '1',
            value: '1',
        },
        {
            label: '2',
            value: '2',
        },
        {
            label: '3',
            value: '3',
        },
        {
            label: '4',
            value: '4',
        },
        {
            label: 'None',
            value: 'None',
        },
    ],
    windScreenSizesReferenceData: [
        {
            label: 'Sedan: 1200 mm – 1500 mm (W) x 500 mm – 900 mm (H)',
            value: 'Sedan: 1200 mm – 1500 mm (W) x 500 mm – 900 mm (H)',
        },
        {
            label: 'SUV: 1300 mm – 1600 mm (W) x 600 mm – 1000 mm (H)',
            value: 'SUV: 1300 mm – 1600 mm (W) x 600 mm – 1000 mm (H)',
        },
        {
            label: 'Pickup Truck: 1300 mm – 1700 mm (W) x 500 mm – 900 mm (H)',
            value: 'Pickup Truck: 1300 mm – 1700 mm (W) x 500 mm – 900 mm (H)',
        },
        {
            label: 'Minibus/Taxi: 1400 mm – 1800 mm (W) x 700 mm – 1100 mm (H)',
            value: 'Minibus/Taxi: 1400 mm – 1800 mm (W) x 700 mm – 1100 mm (H)',
        },
        {
            label: 'Truck: 1500 mm – 2000 mm (W) x 800 mm – 1200 mm (H)',
            value: 'Truck: 1500 mm – 2000 mm (W) x 800 mm – 1200 mm (H)',
        },
    ],
    weatherConditionReferenceData: [
        {
            label: 'Rainy',
            value: 'Rainy',
        },
        {
            label: 'Stormy',
            value: 'Stormy',
        },
        {
            label: 'Foggy',
            value: 'Foggy',
        },
        {
            label: 'Windy',
            value: 'Windy',
        },
        {
            label: 'Hailstorm',
            value: 'Hailstorm',
        },
        {
            label: 'Dusty',
            value: 'Dusty',
        },
        {
            label: 'Sunny (Glare-related incidents)',
            value: 'Sunny (Glare-related incidents)',
        },
        {
            label: 'Other',
            value: 'Other',
        },
    ],
    visibilityReferenceData: [
        {
            label: 'Clear',
            value: 'Clear',
        },
        {
            label: 'Poor',
            value: 'Poor',
        },
        {
            label: 'Foggy',
            value: 'Foggy',
        },
        {
            label: 'Dusty',
            value: 'Dusty',
        },
        {
            label: 'Hazy',
            value: 'Hazy',
        },
        {
            label: 'Night time (Low Light)',
            value: 'Night time (Low Light)',
        },
        {
            label: 'Glare (Sun or Headlights)',
            value: 'Glare (Sun or Headlights)',
        },
        {
            label: 'Other',
            value: 'Other',
        },
    ],
    roadSurfaceReferenceData: [
        {
            label: 'Tarmac',
            value: 'Tarmac',
        },
        {
            label: 'Gravel',
            value: 'Gravel',
        },
        {
            label: 'Sand',
            value: 'Sand',
        },
        {
            label: 'Mud',
            value: 'Mud',
        },
        {
            label: 'Pothole-damaged',
            value: 'Pothole-damaged',
        },
        {
            label: 'Slippery',
            value: 'Slippery',
        },
        {
            label: 'Uneven',
            value: 'Uneven',
        },
        {
            label: 'Other',
            value: 'Other',
        },
    ],
    roadWidthReferenceData: [
        {
            label: 'Single-lane roads',
            value: 'Single-lane roads',
        },
        {
            label: 'Two-lane roads',
            value: 'Two-lane roads',
        },
        {
            label: 'Major highways',
            value: 'Major highways',
        },
        {
            label: 'Urban roads',
            value: 'Urban roads',
        },
        {
            label: 'Gravel roads',
            value: 'Gravel roads',
        },
        {
            label: 'Other',
            value: 'Other',
        },
    ],
    vehicleLightReferenceData: [
        {
            label: 'Headlights',
            value: 'Headlights',
        },
        {
            label: 'Fog Lights',
            value: 'Fog Lights',
        },
        {
            label: 'Hazard Lights',
            value: 'Hazard Lights',
        },
        {
            label: 'Brake Lights',
            value: 'Brake Lights',
        },
        {
            label: 'Indicator Lights',
            value: 'Indicator Lights',
        },
        {
            label: 'Reverse Lights',
            value: 'Reverse Lights',
        },
        {
            label: 'Parking Lights',
            value: 'Parking Lights',
        },
        {
            label: 'Other',
            value: 'Other',
        },
    ],
}));
